import { render, staticRenderFns } from "./modalDriverFullfilment.vue?vue&type=template&id=56a3c050&scoped=true"
import script from "./modalDriverFullfilment.vue?vue&type=script&lang=js"
export * from "./modalDriverFullfilment.vue?vue&type=script&lang=js"
import style0 from "./modalDriverFullfilment.vue?vue&type=style&index=0&id=56a3c050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a3c050",
  null
  
)

export default component.exports